module.exports = __webpack_public_path__ + "img/close.fb41cf30.svg";